module.exports = __webpack_public_path__ + "static/img/s49.43b01a10.png";